export const environment = {
  production: true,
  HOST:'',
  BASE_URL: '/b2c/eshop',
  B2C_URL: '/b2c',
  ESHOP_URL: '/b2c/eshop',
  SAS_URL: '/b2c/sas',
  LINK_URL: '/b2c/addon',
  ECARE_URL: '/b2c',
  CMS_HOST:  '/', //'http://uat-cms.etisalat.corp.ae/dx_etisalat_ae_stg/',//uat-cms.etisalat.corp.ae
  PREPHIRAL_UR: '',
  ATG: 'http://au3565:7011/eshop',
  GTM: 'GTM-TSZ46Z',
  MAP_KEY: '' 

};
